import { useEffect, useState } from 'react'
import { useAppStore } from '../stores/app-store'
import type { RunStatus } from '../shared/types'

const STATUS_COLORS: Record<RunStatus, string> = {
  idle: '#3f3f46',
  'generating-prd': '#5b8def',
  running: '#00ff88',
  publishing: '#a78bfa',
  complete: '#5b8def',
  error: '#ef4444',
  cancelled: '#eab308'
}

const STATUS_LABELS: Record<RunStatus, string> = {
  idle: 'IDLE',
  'generating-prd': 'GENERATING',
  running: 'RUNNING',
  publishing: 'PUBLISHING',
  complete: 'COMPLETE',
  error: 'ERROR',
  cancelled: 'CANCELLED'
}

export function StatusBar() {
  const { status, iteration, maxIterationsRunning, startTime } = useAppStore()
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    if (!startTime) {
      return
    }

    const interval = setInterval(() => {
      setElapsed(Date.now() - startTime)
    }, 1000)

    return () => clearInterval(interval)
  }, [startTime])

  const formatTime = (ms: number): string => {
    const s = Math.floor(ms / 1000)
    const m = Math.floor(s / 60)
    const sec = s % 60
    return `${m}:${sec.toString().padStart(2, '0')}`
  }

  const progress = maxIterationsRunning > 0 ? (iteration / maxIterationsRunning) * 100 : 0
  const isActive = status === 'running' || status === 'generating-prd' || status === 'publishing'

  return (
    <div className="status-bar">
      <div className="status-indicator">
        <span
          className={`status-dot ${isActive ? 'pulsing' : ''}`}
          style={{ backgroundColor: STATUS_COLORS[status] }}
        />
        <span className="status-label">{STATUS_LABELS[status]}</span>
      </div>

      {(status === 'running' || status === 'publishing' || status === 'complete' || status === 'cancelled') && (
        <div className="status-progress">
          <span className="iteration-count">
            {iteration}/{maxIterationsRunning}
          </span>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }} />
          </div>
        </div>
      )}

      {startTime && (
        <span className="elapsed-time">{formatTime(elapsed)}</span>
      )}
    </div>
  )
}
